import GLightbox from 'glightbox';

var resizeDecks = function() {
  document.querySelectorAll('.mtggoldfish_widget').forEach(function(iframe) {
    try {
      var body = iframe.contentDocument && iframe.contentDocument.body;
      if (body) iframe.style.height = (body.offsetHeight + 5) + 'px';
    } catch(e) {}
  });
};

var pollResizeDecks = function() {
  var needToPoll = false;
  document.querySelectorAll('.mtggoldfish_widget').forEach(function(iframe) {
    try {
      var body = iframe.contentDocument && iframe.contentDocument.body;
      if (body && body.querySelector('.ajax-spinner')) needToPoll = true;
    } catch(e) {}
  });
  resizeDecks();
  if (needToPoll) {
    setTimeout(pollResizeDecks, 500);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.iFrameResize === 'function') {
    window.iFrameResize({ log: false, checkOrigin: false }, '.mtggoldfish_widget');
  }

  window.addEventListener('resize', resizeDecks);
  document.querySelectorAll(".mtggoldfish_widget").forEach(function(iframe) {
    iframe.addEventListener('load', pollResizeDecks);
  });

  // Spoiler tags
  document.querySelectorAll(".spoilertag").forEach(function(spoiler) {
    var trigger = document.createElement('p');
    trigger.innerHTML = "<a class='spoilertag-trigger' href='javascript:;'>Spoiler. Hover or click here to reveal.</a>";
    spoiler.parentNode.insertBefore(trigger, spoiler);
    var blocker = document.createElement('div');
    blocker.className = 'spoilertag-blocker';
    spoiler.appendChild(blocker);
    spoiler.style.visibility = 'visible';
  });

  document.addEventListener('mouseover', function(e) {
    if (!e.target || !e.target.matches('.spoilertag-trigger')) return;
    var next = e.target.closest('p').nextElementSibling;
    var b = next ? next.querySelector('.spoilertag-blocker') : null;
    if (b) { b.style.opacity = '0'; b.style.zIndex = '-1'; }
  });
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.spoilertag-trigger')) return;
    var next = e.target.closest('p').nextElementSibling;
    var b = next ? next.querySelector('.spoilertag-blocker') : null;
    if (b) { b.style.opacity = '0'; b.style.zIndex = '-1'; }
  });

  // Article form tag add
  var addBtn = document.querySelector(".article-form-add-btn");
  if (addBtn) {
    addBtn.addEventListener('click', function() {
      var input = document.querySelector(".article-form-add-input");
      var tag = input ? input.value.trim() : '';
      if (tag !== '') {
        var tagList = document.querySelector(".article-form-taglist");
        if (tagList) {
          var span = document.createElement('span');
          span.className = 'article-tag label edit';
          span.textContent = tag + ' x';
          var hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'article[tag_list][]';
          hiddenInput.value = tag;
          span.appendChild(hiddenInput);
          tagList.appendChild(span);
        }
      }
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.article-tag.edit')) return;
    e.target.remove();
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.articles-series-show-more-btn')) return;
    var items = document.querySelectorAll(".articles-series-show-more");
    var shown = 0;
    items.forEach(function(item) {
      if (shown < 10) {
        item.style.display = '';
        item.classList.remove("articles-series-show-more");
        shown++;
      }
    });
    if (!document.querySelector(".articles-series-show-more")) {
      var btn = document.querySelector(".articles-series-show-more-btn");
      if (btn) btn.style.display = 'none';
    }
  });
});

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  document.querySelectorAll('.article-slideshow').forEach(function(slideshow) {
    var id = slideshow.getAttribute('id');
    var images = slideshow.querySelectorAll('.article-slideshow-image');
    images.forEach(function(img) {
      img.setAttribute('data-gallery', id);
    });
    GLightbox({ selector: '#' + id + ' .article-slideshow-image' });
  });
});
